import ManageInvoice from '@/services/manage_invoice'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const changeStatus = async ({ commit }, obj = { invoice_ids: [], rescue_status: '' }) => {
  return new Promise(async (resolve, reject) => {
    ManageInvoice.changeStatus(obj).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const sendDocs = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    ManageInvoice.sendDocs(payload).then((response) => {
      commit('RESET_ERRORS_DOCS')
      resolve(response.data)
    }).catch((error) => {
      commit('SET_ERRORS_DOCS', error.response.data)
      reject(error)
    })
  })
}

const changeStatusDoc = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    ManageInvoice.changeStatusDoc(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      commit('SET_ERRORS_DOCS', error.response.data)
      reject(error)
    })
  })
}

const resetErrors = ({ commit }) => {
  commit('RESET_ERRORS_DOCS')
}

export default {
  changeStatus,
  sendDocs,
  changeStatusDoc,
  resetErrors
}



// WEBPACK FOOTER //
// ./src/features/manager_invoices/store/actions.js